<div class="gird-wrapper">
    <angular-slickgrid
      [gridId]="tableName"
      [columnDefinitions]="columnDefinitions"
      [gridOptions]="gridOptions"
      [dataset]="dataSet"
      (onAngularGridCreated)="angularGridReady($event)"
    >
    </angular-slickgrid>
</div>